import { FC, ButtonHTMLAttributes } from 'react'
import { Button } from '@/root/ui/shared/Button/Button'
import { CloseIcon } from '@/root/ui/shared/icons/CloseIcon'

interface CancelButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string
}

export const CancelButton: FC<CancelButtonProps> = ({ title, ...props }) => {
  return (
    <Button type="button" variant="default" className="border-neutral-dark h-9 w-40 border text-base" {...props}>
      <div className="text-neutral-medium-light flex items-center justify-center gap-2">
        <CloseIcon color="neutral-medium-light" width={16} height={16} data-testid={undefined} />
        <div>{title}</div>
      </div>
    </Button>
  )
}
